import React from "react";
import { Button, Popover, MenuItem, Menu, Position } from "@blueprintjs/core";
import { I18n } from "react-redux-i18n";
import { getMultiplierAndTimeInterval } from './utils';

const BOOKING_DURATION = Array.from({ length: 30 }, (_, i) => i + 1);
const calculateDurationInMinutes = (multiplier, time_interval) => {
    const time_intervals = {
        minute: multiplier,
        hour: multiplier * 60,
        day: multiplier * 60 * 24,
        week: multiplier * 60 * 24 * 7
    }
    return time_intervals[time_interval];
}

class MaxBookingDuration extends React.Component {
    state = {
        time_interval_multiplier: -1,
        time_interval: 'hour'
    }

    componentDidUpdate(prevProps) {
        if (prevProps.current_value !== this.props.current_value) {
            const result = getMultiplierAndTimeInterval(this.props.current_value);
            if (result.time_interval_multiplier > 0) {
                this.setState(result);
            } else {
                this.setState({ time_interval_multiplier: -1, time_interval: 'hour' });
            }
        }
    }

    onIntervalMultiplierChange = (time_interval_multiplier) => {
        if (time_interval_multiplier === -1) {
            this.props.onValueChange(-1);
        } else {
            this.props.onValueChange(calculateDurationInMinutes(time_interval_multiplier, this.state.time_interval))
        }
        this.setState({ time_interval_multiplier })
    }

    onTimeIntervalChange = (time_interval) => {
        this.props.onValueChange(calculateDurationInMinutes(this.state.time_interval_multiplier, time_interval))
        this.setState({ time_interval })
    }

    render() {
        const { time_interval_multiplier, time_interval } = this.state;
        return (
            <>
                <div className="booking-duration-wrapper">
                    <Popover
                        content={
                            <Menu className="prylpoolen-booking-popover">
                                <MenuItem text={I18n.t('new_circle.unlimited')} onClick={() => { this.onIntervalMultiplierChange(-1) }} />
                                {
                                    BOOKING_DURATION.map((duration) => {
                                        return <MenuItem text={duration} onClick={() => { this.onIntervalMultiplierChange(duration) }} key={duration} />
                                    })
                                }
                            </Menu>
                        }
                        position={Position.BOTTOM_LEFT}
                    >
                        <Button rightIcon="caret-down" className="input-button right select-button">
                            {time_interval_multiplier === -1 ? I18n.t('new_circle.unlimited') : time_interval_multiplier}
                        </Button>
                    </Popover>

                    {time_interval_multiplier !== -1 &&
                        <Popover
                            content={
                                <Menu className="prylpoolen-booking-popover">
                                    <MenuItem text={time_interval_multiplier > 1 ? I18n.t('minutes') : I18n.t('minute')} onClick={() => { this.onTimeIntervalChange('minute') }} />
                                    <MenuItem text={time_interval_multiplier > 1 ? I18n.t('hours') : I18n.t('hour')} onClick={() => { this.onTimeIntervalChange('hour') }} />
                                    <MenuItem text={time_interval_multiplier > 1 ? I18n.t('days') : I18n.t('day')} onClick={() => { this.onTimeIntervalChange('day') }} />
                                    <MenuItem text={time_interval_multiplier > 1 ? I18n.t('weeks') : I18n.t('week')} onClick={() => { this.onTimeIntervalChange('week') }} />
                                </Menu>
                            }
                            position={Position.BOTTOM_LEFT}
                        >
                            <Button rightIcon="caret-down" className="input-button right select-button">
                                {I18n.t(`${time_interval}${time_interval_multiplier > 1 ? 's' : ''}`)}
                            </Button>
                        </Popover>
                    }
                </div>
            </>
        );
    }
}

export default MaxBookingDuration;